import RealTimeGradientCalculator from './RealTimeGradientCalculator';

export default RealTimeGradientCalculator;
